import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';


@Injectable()

export class AuthenticationService {
    constructor(private http: Http, @Inject(APP_CONFIG) private config: IAppConfig) { }

    authenticate(email: string, password: string) {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const body = { 'email': email, 'password': password };
        return this.http.post(this.config.apiEndpoint + 'login', body, {headers: headers})
            .map(
                (res: Response) => {
                    const user = res.json();
                    return user;
                }
            )
            .catch(this.handleErrorObservable);
    }

    socialauthenticate(email: string, password: string) {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const body = JSON.stringify({ 'email': email, 'password': password });
        return this.http.post(this.config.apiEndpoint + 'social-login', body, {headers: headers})
            .map(
                (res: Response) => {
                    const user = res.json();
                    return user;
                }
            )
            .catch(this.handleErrorObservable);
    }

    forgotPassword(email: string) {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const body = JSON.stringify({ 'email': email });
        return this.http.post(this.config.apiEndpoint + 'forgot-password', body, {headers: headers})
            .map(
                (res: Response) => {
                    const result = res.json();
                    return result;
                }
            )
            .catch(this.handleErrorObservable);
    }

    resetPassword(new_password: string, confirm_password: string, token: string) {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const body = JSON.stringify({ 'new_password': new_password, 'confirm_password': confirm_password, 'token': token });
        return this.http.post(this.config.apiEndpoint + 'reset-password', body, {headers: headers})
            .map(
                (res: Response) => {
                    const result = res.json();
                    return result;
                }
            )
            .catch(this.handleErrorObservable);
    }

    changePassword(new_password: string, confirm_password: string, current_password: string) {
        
        const token = localStorage.getItem('token');
        const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': token});
        const body = JSON.stringify({ 'new_password': new_password, 'confirm_password': confirm_password, 'current_password': current_password });
        return this.http.post(this.config.apiEndpoint + 'change-password', body, {headers: headers})
            .map(
                (res: Response) => {
                    const result = res.json();
                    return result;
                }
            )
            .catch(this.handleErrorObservable);
    }

    verifyToken(token: string) {

        const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': token});

        const body = JSON.stringify({ 'token': token });
        return this.http.post(this.config.apiEndpoint + 'getDetails', body, {headers: headers})
            .map(
                (res: Response) => {
                    const result = res.json();
                    return result;
                }
            )
            .catch(this.handleErrorObservable);
    }

    addStudentPartner$(info: any): Observable<any> {
        const token = localStorage.getItem('token');
        const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': token});
        return this.http.post(this.config.apiEndpoint + 'add-student-partner', info, {
            headers: headers
          })
          .catch(this.handleErrorObservable);
    }

    //get-financial-year

    getFinancialYear() {
    
        const token = localStorage.getItem('token');
        let headers = new Headers({ 'Authorization': token });
        let options = new RequestOptions({ headers: headers });
    
        return this.http.get(this.config.apiEndpoint + 'get-financial-year', options)
        .map((res => res.json()))
            .catch(this.handleErrorObservable);
      }

    private handleErrorObservable (error: Response | any) {
        console.log(error.json());
        /* if(!error.json().error){
            alert('Please check your internet connection');
        } */
        return Observable.throw( error.json().error || error.json() || 'Server Error' );
    }

    getDomainName() {
        return this.config.domainname;
    }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/authenticate.service.ts